<template>
  <v-btn
    tag="a"
    primary flat
    :href="url"
    :download="filename">
    {{ filename }}
  </v-btn>
</template>

<script>
  export default {
    props: {
      url: {
        type: String
      },
      filename: {
        type: String,
        default: () => {
          try {
            return this.url.split('?')[0].split('/').reverse()[0]
          } catch (e) {
            return ''
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Attachment.vue